module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/036-central-african-republic-83fea6ab2163caf55bd21f1291d4b322.svg";